import { gameStats } from '@/mocks/home';

export default function GameStats() {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20ancient%20Chinese%20palace%20interior%20with%20warm%20golden%20lanterns%20and%20ornate%20decorations%2C%20atmospheric%20lighting%2C%20rich%20amber%20and%20crimson%20tones%2C%20cinematic%20game%20environment%20art%2C%20grand%20hall%2C%20mystical%20atmosphere&width=1600&height=600&seq=stats-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-secondary-900/90 via-secondary-900/85 to-secondary-900/90"></div>
      </div>

      <div className="relative z-10 mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-3">
            千万玩家的共同选择
          </h2>
          <p className="text-foreground-300 text-sm md:text-base">
            用数据证明实力，以口碑赢得信赖
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {gameStats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl font-heading font-bold text-accent-400 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-300">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}